import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveRegisterDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/company/root-company';
    return this.http.post(url, payload);
  }
}
